import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["article"]
  static values = { workspaceSlug: String }

  connect() {
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { threshold: 0.5 }
    )
    this.articleTargets.forEach(el => this.observer.observe(el))
  }

  disconnect() {
    this.observer.disconnect()
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const articleId = entry.target.dataset.articleId
        if (articleId) {
          this.updateArticle(articleId, "in_progress")
        }
      }
    })
  }

  updateArticle(articleId, state) {
    const token = document.querySelector("[name='csrf-token']")?.content
    if (!token) return

    fetch(`/w/${this.workspaceSlugValue}/articles/${articleId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ article: { reading_state: state } })
    })
  }
}
